<template>
  <div class="filter">
    <div class="filters-item-desktop">
      <div ref="filter_name" class="filter-name" @click="switchDropdown" v-click-outside="closeDropdown">
        <span class="filter">{{ propertyLocaleName }}</span>
        <i v-if="selectOptions.length" class="svg-icon arrow" :class="{'rotate-180': showDropdown}"></i>
      </div>
      <div class="selected-filters">
        <template v-for="v in selectedValue">
          <div class="sel-filter">
            <a href="#" @click.prevent="clearValue(v)" :aria-label="$t('clear')">
              <span>{{ v }}</span>
              <i class="svg-icon cross"></i>
            </a>
          </div>
        </template>
      </div>
      <v-select v-model="selectedValue" :options="selectOptions" :multiple="true" :searchable="false" transition="fade"
                :dropdown-should-open="() => showDropdown && selectOptions.length" @option:selected="setFilterValue"
                :style="{'min-width': `${dropdownWidth}px`}">
        <template #no-options="{search, searching, loading}">
          <span></span>
        </template>
      </v-select>
    </div>
    <div class="filters-item-mobile">
      <div class="container filter-options"
           v-show="action === prop.id"
           :class="{'hidden': action !== prop.id}">
        <div class="filter-options-name" @click="action = null; showChild = false">
          <i class="svg-icon arrow-mobile"></i>
          <span>{{ propertyLocaleName }}</span>
        </div>

        <div v-for="option in selectOptions">
          <span @click="setFilterValueMobile(option)">{{ option }}</span>
        </div>
      </div>


      <div class="filter-main" @click="action = prop.id; showChild = true">
        <div class="filter-name" :class="{'active': action === prop.id }">
          <span>{{ propertyLocaleName }}</span>
          <i v-if="selectOptions.length" class="svg-icon arrow"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  props: ['prop', 'initialQuery'],
  data() {
    return {
      selectedValue: [],
      showDropdown: false,
      dropdownWidth: 0,
      action: null,
      showChild: false,
    }
  },
  watch: {
    '$route.query': {
      handler: function (query) {
        if (this.initialQuery) {
          let value = query[`p${this.prop.id}`];
          value = (value instanceof Array) ? value : (value ? [value] : []);
          let updatedFromSelect = (value.length === this.selectedValue.length) && value.every((v, i) => {
            return v === this.selectedValue[i];
          });
          if (!updatedFromSelect) {
            this.setFilterValue(value);
          }
        } else {
          this.selectedValue = [];
        }
      },
      deep: true,
    },
    showChild(value) {
      if (value) {
        this.setSlideTransition('slide-right');
      } else {
        this.setSlideTransition('slide-left');
      }
    },
    selectedValue() {
      this.$emit('set-selected-filters', this.prop.id, this.selectedValue);
    }
  },
  computed: {
    propertyLocaleName() {
      let data = this.prop?.property_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
      return data.name || this.prop.name;
    },
    selectOptions() {
      return this.prop.filters.filter(x => !this.selectedValue.includes(x));
    },
  },
  created() {
    if (this.initialQuery) {
      let value = this.$route.query[`p${this.prop.id}`];
      if (value) {
        this.selectedValue = (value instanceof Array) ? value : [value];
      }
    }
  },
  methods: {
    switchDropdown() {
      this.dropdownWidth = this.$refs.filter_name.clientWidth;
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    setFilterValue(value) {
      this.selectedValue = value.sort();
      this.$emit('set-filter', this.prop.id, value);
      this.closeDropdown();
    },
    setFilterValueMobile(value) {
      this.selectedValue.push(value);
      this.selectedValue = [...new Set(this.selectedValue)]
      this.$emit('set-filter', this.prop.id, this.selectedValue);
    },
    clearValue(value) {
      this.setFilterValue(this.selectedValue.filter(x => x !== value));
    },
    clearValueMobile(value) {
      this.setFilterValueMobile(this.selectedValue.filter(x => x !== value));
    },
    setSlideTransition(slideDirection) {
      setTimeout(() => {
        this.slideTransition = slideDirection;
      }, 500);
    },
  },
}
</script>
